import ApiCore from '@/api/api-core'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class UndefinedFurnitureCarTariff extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/report/undefinedTariff/furniture/car`)
  }

  report(filter, showProgress) {
    return this._request({
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
